import React from 'react';

import { LoyaltyBannerDesktop } from './LoyaltyBanner.Desktop';
import { LoyaltyBannerMobile } from './LoyaltyBanner.Mobile';

interface LoyaltyBannerProps {
  points: number;
  memberSince?: string;
}

export const LoyaltyBanner = ({ points, memberSince }: LoyaltyBannerProps) => {
  return (
    <>
      {/* Mobile View - Below tablet breakpoint (768px) */}
      <div className="tablet:hidden">
        <LoyaltyBannerMobile points={points} />
      </div>

      {/* Desktop View - Above tablet breakpoint */}
      <div className="hidden tablet:block">
        <LoyaltyBannerDesktop points={points} memberSince={memberSince} />
      </div>
    </>
  );
};
